import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sending: false,
    confirmationModal: false,
    error: null,
    api: {},
  },
  mutations: {
    set(state) {
      state.sending = true;
    },
    unset(state) {
      state.sending = false;
    },
    api(state, api) {
      state.api = api;
    },
    error(state, er) {
      state.error = er;
    },
  },
});
